// @flow

import { getSafeCheckoutPaymentOptions, type OpenedIncomingPayment } from '@tectonics/prs/incoming-payment';

export function getSupportedCashOptions(incomingPayment: OpenedIncomingPayment): ImmutableArray<string> {
  const checkoutPaymentOptions = getSafeCheckoutPaymentOptions(incomingPayment);
  return checkoutPaymentOptions.cash;
}
